import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { GoalYearInterface } from '../+models';

export const GOAL_YEAR_SERVICE_TOKEN = new InjectionToken('GoalYearService');

export interface GoalYearServiceInterface {
  getGoalYearsForLearningArea(learningAreaId: number): Observable<GoalYearInterface[]>;
}
